import { takeEvery } from 'redux-saga/effects';
import { onContentWhiteboardChangedSaga } from 'features/content-whiteboard/sagas/onContentWhiteboardUpdatedSaga';
import { onContentWhiteboardDataReceivedSaga } from 'features/content-whiteboard/sagas/onContentWhiteboardDataReceivedSaga';
import { onContentWhiteboardLaserUpdatedSaga } from 'features/content-whiteboard/sagas/onContentWhiteboardLaserUpdatedSaga';
import { requestContentWhiteboardDataSaga } from 'features/content-whiteboard/sagas/requestContentWhiteboardDataSaga';
import { onScreenshareWhiteboardUpdatedSaga } from 'features/content-whiteboard/sagas/onScreenshareWhiteboardUpdatedSaga';
import { onScreenshareWhiteboardDataReceivedSaga } from 'features/content-whiteboard/sagas/onScreenshareWhiteboardDataReceivedSaga';
import { onScreenshareWhiteboardLaserUpdatedSaga } from 'features/content-whiteboard/sagas/onScreenshareWhiteboardLaserUpdatedSaga';
import { requestScreenshareWhiteboardDataSaga } from 'features/content-whiteboard/sagas/requestScreenshareWhiteboardDataSaga';
import {
  requestContentWhiteboardData,
  signalingContentWhiteboardDataReceived,
  signalingContentWhiteboardLaserUpdated,
  signalingContentWhiteboardUpdated,
  signalingScreenshareWhiteboardUpdated,
  signalingScreenshareWhiteboardDataReceived,
  signalingScreenshareWhiteboardLaserUpdated,
  requestScreenshareWhiteboardData,
} from 'features/content-whiteboard/actions';

export default function* contentWhiteboardWatcher() {
  yield takeEvery(signalingContentWhiteboardUpdated, onContentWhiteboardChangedSaga);
  yield takeEvery(signalingContentWhiteboardDataReceived, onContentWhiteboardDataReceivedSaga);
  yield takeEvery(signalingContentWhiteboardLaserUpdated, onContentWhiteboardLaserUpdatedSaga);
  yield takeEvery(requestContentWhiteboardData, requestContentWhiteboardDataSaga);
  yield takeEvery(signalingScreenshareWhiteboardUpdated, onScreenshareWhiteboardUpdatedSaga);
  yield takeEvery(
    signalingScreenshareWhiteboardDataReceived,
    onScreenshareWhiteboardDataReceivedSaga
  );
  yield takeEvery(
    signalingScreenshareWhiteboardLaserUpdated,
    onScreenshareWhiteboardLaserUpdatedSaga
  );
  yield takeEvery(requestScreenshareWhiteboardData, requestScreenshareWhiteboardDataSaga);
}
